module.exports = __webpack_public_path__ + "img/01.cfab060e.png";